import { render, staticRenderFns } from "./RemoveRowButton.vue?vue&type=template&id=5a2c2b46"
import script from "./RemoveRowButton.vue?vue&type=script&lang=ts"
export * from "./RemoveRowButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports